import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Box, CircularProgress, Typography, Container, Paper } from '@mui/material';
import AuthService from '../services/auth';
import api from '../services/api';

const OAuth2Callback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [error, setError] = useState(null);

  useEffect(() => {
    const processOAuth2Callback = async () => {
      try {
        // Get user data from URL parameters
        const params = new URLSearchParams(location.search);
        const encodedUser = params.get('user');

        if (!encodedUser) {
          throw new Error('Не вдалося отримати дані автентифікації');
        }

        // Decode user data
        const userDataString = atob(encodedUser);
        const [id, email, firstName, lastName, role] = userDataString.split(':');

        // Create user object
        const user = {
          id,
          email,
          firstName,
          lastName,
          role
        };

        // User data is stored in the server, token is in HTTP-only cookie
        // No need to store user data in localStorage

        // Check if user has a phone number
        try {
          const response = await api.get('/users/check-phone');
          if (response.data && !response.data.hasPhone) {
            // Redirect to phone input page if user doesn't have a phone number
            navigate('/phone-input');
            return;
          }
        } catch (phoneCheckError) {
          console.error('Error checking phone number:', phoneCheckError);
          // Continue to home page even if phone check fails
        }

        // Redirect to home page
        navigate('/');
      } catch (err) {
        console.error('OAuth2 callback error:', err);
        setError('Помилка автентифікації. Будь ласка, спробуйте ще раз.');
        setTimeout(() => {
          navigate('/login');
        }, 3000);
      }
    };

    processOAuth2Callback();
  }, [location, navigate]);

  return (
    <Container maxWidth="sm">
      <Box sx={{ mt: 8, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <Paper elevation={3} sx={{ p: 4, width: '100%', borderRadius: 2 }}>
          {error ? (
            <Box sx={{ textAlign: 'center' }}>
              <Typography variant="h6" color="error" gutterBottom>
                {error}
              </Typography>
              <Typography variant="body1">
                Перенаправлення на сторінку входу...
              </Typography>
            </Box>
          ) : (
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <CircularProgress size={60} sx={{ mb: 3 }} />
              <Typography variant="h6" gutterBottom>
                Автентифікація успішна
              </Typography>
              <Typography variant="body1">
                Перенаправлення на головну сторінку...
              </Typography>
            </Box>
          )}
        </Paper>
      </Box>
    </Container>
  );
};

export default OAuth2Callback;
